"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptedOfferDtoSignatureStatusEnum = exports.AcceptedOfferDtoStatusEnum = void 0;
exports.instanceOfAcceptedOfferDto = instanceOfAcceptedOfferDto;
exports.AcceptedOfferDtoFromJSON = AcceptedOfferDtoFromJSON;
exports.AcceptedOfferDtoFromJSONTyped = AcceptedOfferDtoFromJSONTyped;
exports.AcceptedOfferDtoToJSON = AcceptedOfferDtoToJSON;
exports.AcceptedOfferDtoToJSONTyped = AcceptedOfferDtoToJSONTyped;
/**
 * @export
 */
exports.AcceptedOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.AcceptedOfferDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the AcceptedOfferDto interface.
 */
function instanceOfAcceptedOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('contractSubjects' in value) || value['contractSubjects'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('isCounterOffer' in value) || value['isCounterOffer'] === undefined)
        return false;
    if (!('acceptedAt' in value) || value['acceptedAt'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function AcceptedOfferDtoFromJSON(json) {
    return AcceptedOfferDtoFromJSONTyped(json, false);
}
function AcceptedOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'listingId': json['listingId'],
        'primary_buyer_id': json['primary_buyer_id'] == null ? undefined : json['primary_buyer_id'],
        'offerPrice': json['offerPrice'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'conditions': json['conditions'] == null ? undefined : json['conditions'],
        'contractSubjects': json['contractSubjects'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'isCounterOffer': json['isCounterOffer'],
        'parentOfferId': json['parentOfferId'] == null ? undefined : json['parentOfferId'],
        'rejectedReason': json['rejectedReason'] == null ? undefined : json['rejectedReason'],
        'acceptedAt': json['acceptedAt'],
        'rejectedAt': json['rejectedAt'] == null ? undefined : json['rejectedAt'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}
function AcceptedOfferDtoToJSON(json) {
    return AcceptedOfferDtoToJSONTyped(json, false);
}
function AcceptedOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'listingId': value['listingId'],
        'primary_buyer_id': value['primary_buyer_id'],
        'offerPrice': value['offerPrice'],
        'depositAmount': value['depositAmount'],
        'settlementDate': value['settlementDate'],
        'conditions': value['conditions'],
        'contractSubjects': value['contractSubjects'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'isCounterOffer': value['isCounterOffer'],
        'parentOfferId': value['parentOfferId'],
        'rejectedReason': value['rejectedReason'],
        'acceptedAt': value['acceptedAt'],
        'rejectedAt': value['rejectedAt'],
        'expiresAt': value['expiresAt'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}
